import { getValidatedVariant } from './envValidator';

export const variant = getValidatedVariant();
